import React from 'react';
import { SidebarLayout } from '../components/SidebarLayout';
import { OfferEmailTemplates } from './OfferEmailTemplates';
import { AllOffers } from './AllOffers';

type TProps = {
  projectId: number;
};

export const OfferPage = (props: TProps) => {
  const { projectId } = props;

  const sections = [
    {
      id: 'offers',
      label: 'Offers',
      component: <AllOffers projectId={projectId} />,
    },
    {
      id: 'offer-email-template',
      label: 'Offer Email Template',
      component: <OfferEmailTemplates projectId={projectId} />,
    },
  ];

  return (
    <SidebarLayout
      sections={sections}
      activeSectionId="offers"
      onlyShowActiveSection
    />
  );
};
